export default __webpack_public_path__ + "static/media/Group 1.9f3a863f.svg";